module.exports = {
  Checkbox: require('./dist/Checkbox').default,
  Label: require('./dist/Label').default,
  Modal: require('./dist/Modal').default,
  Radio: require('./dist/Radio').default,
  Toggle: require('./dist/Toggle').default,
};



//////////////////
// WEBPACK FOOTER
// ./~/synfrastructure/index.js
// module id = 25
// module chunks = 0